import { render, staticRenderFns } from "./UserConcept.vue?vue&type=template&id=f28130fa&scoped=true&"
import script from "./UserConcept.vue?vue&type=script&lang=js&"
export * from "./UserConcept.vue?vue&type=script&lang=js&"
import style0 from "./UserConcept.vue?vue&type=style&index=0&id=f28130fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28130fa",
  null
  
)

export default component.exports